<template>
  <div class="activity-mobile-design">
    <ContentWrap>
      <div class="workspace-head">
        <div>
          <h2>活动移动端设计</h2>
          <p>活动报名模块首页走「多业态模板」：保存后须发布并应用才生效（与商城装修入口一致）。</p>
        </div>
      </div>
    </ContentWrap>
    <MultiIndustryDiyTemplate />
  </div>
</template>

<script lang="ts" setup>
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import MultiIndustryDiyTemplate from '@/views/diy/template/index.vue'

defineOptions({ name: 'ActivityMobileDesign' })

const route = useRoute()
const router = useRouter()

/** 锁定业态/场景，与商城 MallDecoration、概况 openDecorate 入参一致 */
watch(
  () => [route.query.industry, route.query.scene] as const,
  () => {
    if (String(route.query.industry || '') === 'activity' && String(route.query.scene || '') === 'home') {
      return
    }
    router.replace({
      path: route.path,
      query: { ...route.query, industry: 'activity', scene: 'home' }
    })
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.activity-mobile-design {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.workspace-head h2 {
  margin: 0;
  font-size: 18px;
}

.workspace-head p {
  margin: 4px 0 0;
  color: var(--el-text-color-secondary);
  font-size: 12px;
  line-height: 1.5;
  max-width: 640px;
}
</style>
